import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import { app } from "../../../firebase-config.js";

const db = getFirestore(app);

export const AuthorRequestsTab = async (container) => {
    container.innerHTML = '<div class="text-center py-10">Loading Requests...</div>';

    try {
        const q = query(collection(db, "users"), where("authorStatus", "==", "pending"));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
            container.innerHTML = `<div class="bg-white p-10 rounded-lg shadow-sm text-center text-gray-500">No pending author requests.</div>`;
            return;
        }

        let html = `
            <div class="bg-white shadow sm:rounded-lg overflow-hidden">
                <ul class="divide-y divide-gray-200">
        `;

        snapshot.forEach(docSnap => {
            const data = docSnap.data();
            const req = data.authorRequestData || {};
            const date = req.requestedAt ? req.requestedAt.toDate().toLocaleDateString() : 'Unknown';

            html += `
                <li class="p-6">
                    <div class="flex flex-col md:flex-row md:items-start justify-between gap-6">
                        <div class="flex-1">
                            <div class="flex items-center gap-2 mb-2">
                                <span class="text-lg font-bold text-gray-900">${data.email}</span>
                                <span class="bg-yellow-100 text-yellow-800 text-xs px-2 py-0.5 rounded-full font-bold">Pending</span>
                            </div>
                            <div class="text-sm text-gray-600 space-y-3">
                                <div>
                                    <span class="font-bold text-gray-900 block mb-1">Introduction / Plan:</span>
                                    <p class="whitespace-pre-wrap bg-gray-50 p-3 rounded-lg border border-gray-100">${req.introduction || 'No introduction provided.'}</p>
                                </div>
                                ${req.portfolioUrl ? `
                                <div>
                                    <span class="font-bold text-gray-900 block mb-1">Portfolio:</span>
                                    <a href="${req.portfolioUrl}" target="_blank" class="text-blue-600 hover:underline break-all">${req.portfolioUrl}</a>
                                </div>` : ''}
                                ${req.contactEmail ? `
                                <div>
                                    <span class="font-bold text-gray-900 block mb-1">Contact Email:</span>
                                    <a href="mailto:${req.contactEmail}" class="text-blue-600 hover:underline">${req.contactEmail}</a>
                                </div>` : ''}
                                <div class="text-xs text-gray-400 mt-2">Requested on: ${date}</div>
                            </div>
                        </div>
                        <div class="flex flex-row md:flex-col gap-2 shrink-0">
                            <button class="btn-approve px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-bold shadow-sm transition-colors flex items-center justify-center gap-1" data-id="${docSnap.id}">
                                <span class="material-symbols-outlined text-sm">check</span> Approve
                            </button>
                            <button class="btn-reject px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg font-bold transition-colors flex items-center justify-center gap-1" data-id="${docSnap.id}">
                                <span class="material-symbols-outlined text-sm">close</span> Reject
                            </button>
                        </div>
                    </div>
                </li>
            `;
        });

        html += `</ul></div>`;
        container.innerHTML = html;

        // Bind Actions
        container.querySelectorAll('.btn-approve').forEach(btn => {
            btn.onclick = async () => {
                if (await window.Modal.confirm('Approve this user as an Author?', "Approve Author")) {
                    try {
                        const userId = btn.dataset.id;
                        await updateDoc(doc(db, "users", userId), {
                            role: 'author',
                            authorStatus: 'approved'
                        });

                        // Notify
                        const { NotificationTriggerService } = await import("../../../services/notification-trigger.service.js");
                        await NotificationTriggerService.notifyAuthorApproved(userId);

                        AuthorRequestsTab(container); // Refresh
                    } catch (e) {
                        await window.Modal.alert('Error: ' + e.message);
                    }
                }
            };
        });

        container.querySelectorAll('.btn-reject').forEach(btn => {
            btn.onclick = async () => {
                if (await window.Modal.confirm('Reject this request?', "Reject Author")) {
                    try {
                        const userId = btn.dataset.id;
                        await updateDoc(doc(db, "users", userId), {
                            authorStatus: 'rejected'
                        });

                        // Notify
                        const { NotificationTriggerService } = await import("../../../services/notification-trigger.service.js");
                        await NotificationTriggerService.notifyAuthorRejected(userId);

                        AuthorRequestsTab(container); // Refresh
                    } catch (e) {
                        await window.Modal.alert('Error: ' + e.message);
                    }
                }
            };
        });

    } catch (e) {
        container.innerHTML = `<p class="text-red-500">Error: ${e.message}</p>`;
    }
};
